import _taggedTemplateLiteral from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CoreHelperUtil, RouterController } from '@web3modal/core';
import { customElement } from '@web3modal/ui';
import { LitElement, html } from 'lit';
import { state } from 'lit/decorators.js';
let W3mAllWalletsView = class W3mAllWalletsView extends LitElement {
  constructor() {
    super(...arguments);
    this.search = '';
    this.onDebouncedSearch = CoreHelperUtil.debounce(value => {
      this.search = value;
    });
  }
  render() {
    const isSearch = this.search.length >= 2;
    return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <wui-flex padding=\"s\" gap=\"s\">\n        <wui-search-bar @inputChange=", "></wui-search-bar>\n        ", "\n      </wui-flex>\n      ", "\n    "])), this.onInputChange.bind(this), this.qrButtonTemplate(), isSearch ? html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<w3m-all-wallets-search query=", "></w3m-all-wallets-search>"])), this.search) : html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<w3m-all-wallets-list></w3m-all-wallets-list>"]))));
  }
  onInputChange(event) {
    this.onDebouncedSearch(event.detail);
  }
  qrButtonTemplate() {
    if (CoreHelperUtil.isMobile()) {
      return html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        <wui-icon-box\n          size=\"lg\"\n          iconSize=\"xl\"\n          iconColor=\"accent-100\"\n          backgroundColor=\"accent-100\"\n          icon=\"qrCode\"\n          background=\"transparent\"\n          border\n          borderColor=\"wui-accent-glass-010\"\n          @click=", "\n        ></wui-icon-box>\n      "])), this.onWalletConnectQr.bind(this));
    }
    return null;
  }
  onWalletConnectQr() {
    RouterController.push('ConnectingWalletConnect');
  }
};
__decorate([state()], W3mAllWalletsView.prototype, "search", void 0);
W3mAllWalletsView = __decorate([customElement('w3m-all-wallets-view')], W3mAllWalletsView);
export { W3mAllWalletsView };
//# sourceMappingURL=index.js.map